import script from "./IpdPharmacyStatementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IpdPharmacyStatementTable.vue?vue&type=script&setup=true&lang=js"

import "./IpdPharmacyStatementTable.vue?vue&type=style&index=0&id=1c51585a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c51585a"]])

export default __exports__